// extracted by mini-css-extract-plugin
export default {"container":"EntityIntelligentCard-module_container_d6f15e0d"};